import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { ColorSettingAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-color-setting-audit-list',
  templateUrl: './color-setting-audit-list.component.html',
  styleUrls: ['./color-setting-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorSettingAuditListComponent implements OnInit {
  @Input() colorSettingId: number;
  @Input() loading: boolean;
  @Input() colorSettingAudits: ColorSettingAudit[];

  @Output() loadColorSetting = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadColorSetting.emit(this.colorSettingId);
  }

  onNextPage() {
    this.nextPage.emit(this.colorSettingId);
  }
}
